import _ from 'lodash';

const parseId = (str, num) => {
  const words = str.split('_');
  return words.slice(0, -num);
};

export const getParentTarget = (str, num) => {
  const words = parseId(str, num);
  words.shift();
  return words.join('.');
};

export const getParentId = (str, num) => {
  const words = parseId(str, num);
  return words.join('_');
};

export const isConditionMet = (trigger, parentObject) => {
  if (_.isEmpty(trigger)) {
    return true;
  }
  return _.get(parentObject, trigger?.name) === trigger?.value;
};

export const clearFields = async (targetFields, registry, currentSchemaKey) => {
  for (const target of targetFields) {
    await registry.setFormData(undefined, `${currentSchemaKey}.${target}`);
  }
};
